import React, { useEffect } from "react";
import { MiddlewareLayout } from "./MiddlewareLayout";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const MidRoute = ({ children }: Props) => {
  return <MiddlewareLayout>{children}</MiddlewareLayout>;
};
